/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddQuestion } from './addQuestion';


/**
 * Редактировать участников опроса.
 */
export interface PollEditWithParticipants { 
    /**
     * Идентификатор опроса.
     */
    id: string;
    /**
     * Идентификаторы участников для участия в опросе.
     */
    sendTo?: Array<string>;
    /**
     * Название.
     */
    titleText?: string;
    /**
     * Описание.
     */
    descriptionText?: string;
    /**
     * Дата начала опроса.
     */
    dateStart?: string;
    /**
     * Дата окончания опроса.
     */
    dateEnd?: string;
    /**
     * Время прохождения опроса.
     */
    pollDuration?: number;
    /**
     * Идентификатор комитета.
     */
    committeeId?: string;
    /**
     * текст завершающей речи после прохождения опроса.
     */
    completionText?: string;
    /**
     * опция пошагового прохождения опроса.
     */
    displayStepByStep?: boolean;
    /**
     * ограничение на прохождение опроса в минутах.
     */
    timeLimit?: number;
    /**
     * регистрировать время прохождения опроса.
     */
    registerTime?: boolean;
    /**
     * признак что опрос является шаблоном.
     */
    isTemplate?: boolean;
    /**
     * ID использованного шаблона.
     */
    templateId?: string;
    /**
     * Список вариантов ответов
     */
    questions?: Array<AddQuestion>;
    notifyEveryone?: boolean;
}

